import { render, staticRenderFns } from "./PaginaCarregando.vue?vue&type=template&id=ee2a55d0&scoped=true&"
import script from "./PaginaCarregando.vue?vue&type=script&lang=js&"
export * from "./PaginaCarregando.vue?vue&type=script&lang=js&"
import style0 from "./PaginaCarregando.vue?vue&type=style&index=0&id=ee2a55d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2a55d0",
  null
  
)

export default component.exports